import React, { memo, forwardRef } from "react";
const SvgUpsilon = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.872 22.656c-1.072 0-1.936-.136-2.592-.408-.64-.288-1.128-.688-1.464-1.2-.32-.528-.536-1.144-.648-1.848A15.512 15.512 0 0111 16.824v-6.272a1 1 0 011-1h.112a1 1 0 011 1v6.2c0 .912.072 1.68.216 2.304.144.608.424 1.072.84 1.392.432.32 1.056.48 1.872.48.768 0 1.424-.2 1.968-.6.544-.4.952-1.016 1.224-1.848.288-.832.432-1.888.432-3.168 0-1.12-.064-2.12-.192-3-.072-.491-.16-.995-.267-1.511-.131-.638.345-1.249.996-1.249h.074a.97.97 0 01.95.732c.091.375.171.747.239 1.116.112.592.192 1.208.24 1.848.064.64.096 1.36.096 2.16 0 2.48-.52 4.312-1.56 5.496-1.04 1.168-2.496 1.752-4.368 1.752z"
      />
    </svg>
  );
});
SvgUpsilon.displayName = "SvgUpsilon";
const MemoForwardRef = memo(SvgUpsilon);
export default MemoForwardRef;
